




// "use client"

// import React from "react"
// import { Link } from "react-router-dom"
// import Bg from "../../images/shapes/bg_pattern_3.svg"
// import icon1 from "../../images/icons/icon_mail.svg"
// import icon2 from "../../images/icons/icon_calling.svg"
// import icon3 from "../../images/icons/icon_map_mark.svg"
// import icon4 from "../../images/icons/icon_mail_2.svg"
// import Services from "../../api/service"
// import logo from "../../images/flag/white-main-logo.webp"
// import facebook from "../../images/icons/facebook-app-symbol_result.webp"
// import x from "../../images/icons/twitter_result.webp"
// import instagram from "../../images/icons/instagram_result.webp"
// import youtube from "../../images/icons/youtube_result.webp"
// import linkedin from "../../images/icons/linkedin_result.webp"
// import pinterest from "../../images/icons/pinterest_result.webp"

// const ClickHandler = () => {
//   window.scrollTo(10, 0)
// }

// const SubmitHandler = (e) => {
//   e.preventDefault()
// }

// const Footer = (props) => {
//   return (
//     <footer className="site_footer footer_layout_1">
//       <div className="content_box" style={{ backgroundImage: `url(${Bg})` }}>
//         <div className="container">
//           <div className="diract_contact_links text-white">
//             <div className="iconbox_block layout_icon_left">
//               <div className="iconbox_icon">
//                 <img src={icon1} alt="Mail SVG Icon" />
//               </div>
//               <div className="iconbox_content">
//                 <h3 className="iconbox_title">Write to us</h3>
//                 <p className="mb-0">info@rashtechinfo.com</p>
//               </div>
//             </div>
//             <div className="iconbox_block layout_icon_left">
//               <div className="iconbox_icon">
//                 <img src={icon2} alt="Calling Check SVG Icon" />
//               </div>
//               <div className="iconbox_content">
//                 <h3 className="iconbox_title"> Call Us (IND)</h3>
//                 <p className="mb-0">+91 80940 94653</p>
//               </div>
//             </div>
//             <div className="iconbox_block layout_icon_left">
//               <div className="iconbox_icon">
//                 <img src={icon3} alt="Map Mark Check SVG Icon" />
//               </div>
//               <div className="iconbox_content">
//                 <h3 className="iconbox_title">Our Office</h3>
//                 <p className="mb-0">
//                   Shiv Complex, Near Dussehra <br /> Maidan, Alwar (Rajasthan)
//                 </p>
//               </div>
//             </div>
//           </div>
//           <div className="footer_main_content">
//             <div className="row justify-content-lg-between">
//               <div className="col-lg-3 col-md-6 col-sm-6">
//                 <div className="footer_widget pe-md-3">
//                   <img
//                     src={logo}
//                     alt="RashTech-logo"
//                     style={{ marginBottom: "20px" }}
//                   />
//                   <p style={{ marginLeft: "20px" }}>
//                     RashTech Info is a 2018-founded Alwar-based agency
//                     delivering web, app, UI/UX, and digital marketing solutions
//                     for growing businesses.
//                   </p>
//                   <ul className="social_links_block unordered_list">
//                     <li>
//                       <a
//                         href="https://www.facebook.com/rashtechinfo"
//                         target="_blank"
//                         rel="noreferrer"
//                       >
//                         <img
//                           src={facebook}
//                           alt="Facebook Icon"
//                           style={{ width: "18px" }}
//                         />
//                       </a>
//                     </li>
//                     <li>
//                       <a href="https://x.com/rashtechinfo" target="_blank" rel="noreferrer">
//                         <img src={x} alt="X Icon" style={{ width: "18px" }} />
//                       </a>
//                     </li>
//                     <li>
//                       <a
//                         href="https://www.instagram.com/rashtechinfo"
//                         target="_blank"
//                         rel="noreferrer"
//                       >
//                         <img
//                           src={instagram}
//                           alt="Instagram Icon"
//                           style={{ width: "18px" }}
//                         />
//                       </a>
//                     </li>
//                     <li>
//                       <a
//                         href="https://www.linkedin.com/company/officialrashtechinfo"
//                         target="_blank"
//                         rel="noreferrer"
//                       >
//                         <img
//                           src={linkedin}
//                           alt="LinkedIn Icon"
//                           style={{ width: "18px" }}
//                         />
//                       </a>
//                     </li>
//                     <li>
//                       <a
//                         href="https://in.pinterest.com/rashtech_info"
//                         target="_blank"
//                         rel="noreferrer"
//                       >
//                         <img
//                           src={pinterest}
//                           alt="Pinterest Icon"
//                           style={{ width: "18px" }}
//                         />
//                       </a>
//                     </li>
                    
//                     <li>
//                       <a href="https://www.youtube.com/@officialrashtechinfo" target="_blank" rel="noreferrer">
//                         <img src={youtube} alt="YouTube Icon" style={{ width: "18px" }} />
//                       </a>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
              
//               {/* First Column - Quick Links */}
//               <div className="col-lg-2 col-md-6 col-sm-6">
//                 <div className="footer_widget">
//                   <h3 className="footer_info_title">Quick Links</h3>
//                   <ul className="icon_list unordered_list_block" >
//                     <li>
//                       <Link onClick={ClickHandler} to="/">
//                         <span className="icon_list_text">Home</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/about">
//                         <span className="icon_list_text">About Us</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/blog">
//                         <span className="icon_list_text">Blogs</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/portfolio">
//                         <span className="icon_list_text">Portfolio</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/case-study">
//                         <span className="icon_list_text">Case Study</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/career">
//                         <span className="icon_list_text">Career</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/team">
//                         <span className="icon_list_text">Our Team</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/contact">
//                         <span className="icon_list_text">Contact Us</span>
//                       </Link>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
              
//               {/* Second Column - Services */}
//               <div className="col-lg-3 col-md-6 col-sm-6">
//                 <div className="footer_widget">
//                   <h3 className="footer_info_title">Services</h3>
//                   <ul className="icon_list unordered_list_block" >
//                     {Services.slice(0).map((service, srv) => (
//                       <li key={srv}>
//                         {service.footer ? (
//                           <Link
//                             onClick={ClickHandler}
//                             to={`/${service.slug}`}
//                           >
//                             <span className="icon_list_text">
//                               {service.footer}
//                             </span>
//                           </Link>
//                         ) : (
//                           ""
//                         )}
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
              
//               {/* Third Column - Our Industries (Product ki jagah) */}
//               <div className="col-lg-2 col-md-6 col-sm-6">
//                 <div className="footer_widget">
//                   <h3 className="footer_info_title">Our Industries</h3>
//                   <ul className="icon_list unordered_list_block">
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/healthcare">
//                         <span className="icon_list_text">Healthcare</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/education">
//                         <span className="icon_list_text">Education & E‑Learning</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/finance">
//                         <span className="icon_list_text">Finance</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/legal-consultancy">
//                         <span className="icon_list_text">Legal & Consultancy</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/logistics">
//                         <span className="icon_list_text">Logistics</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/insurance">
//                         <span className="icon_list_text">Insurance</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/manufacturing">
//                         <span className="icon_list_text">Manufacturing</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/travel">
//                         <span className="icon_list_text">Travel</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/retail">
//                         <span className="icon_list_text">Retail</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/construction">
//                         <span className="icon_list_text">Construction</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/sports">
//                         <span className="icon_list_text">Sports</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/marketplace">
//                         <span className="icon_list_text">Marketplace</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/beauty-lifestyle">
//                         <span className="icon_list_text">Beauty & Lifestyle</span>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link onClick={ClickHandler} to="/industries/on-demand">
//                         <span className="icon_list_text">On Demand</span>
//                       </Link>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="footer_bottom">
//         <div className="container d-md-flex align-items-md-center justify-content-md-between">
//           <p className="copyright_text m-0">
//             Copyright © {new Date().getFullYear()} - RashTech Info. All Rights
//             Reserved.
//           </p>
//           <div className="copyright_text m-0">
//             <Link onClick={ClickHandler} to="/privacy-policy" style={{ marginRight: "10px" }}>Privacy Policy</Link>
//             <span>|</span>
//             <Link onClick={ClickHandler} to="/terms-and-conditions" style={{ marginLeft: "10px" }}>Terms & Conditions</Link>
//           </div>
//         </div>
//       </div>
//     </footer>
//   )
// }

// export default Footer

"use client"

import React from "react"
import { Link } from "react-router-dom"
import Bg from "../../images/shapes/bg_pattern_3.svg"
import icon1 from "../../images/icons/icon_mail.svg"
import icon2 from "../../images/icons/icon_calling.svg"
import icon3 from "../../images/icons/icon_map_mark.svg"
import icon4 from "../../images/icons/icon_mail_2.svg"
import Services from "../../api/service"
import logo from "../../images/flag/white-main-logo.webp"
import facebook from "../../images/icons/facebook-app-symbol_result.webp"
import x from "../../images/icons/twitter_result.webp"
import instagram from "../../images/icons/instagram_result.webp"
import youtube from "../../images/icons/youtube_result.webp"
import linkedin from "../../images/icons/linkedin_result.webp"
import pinterest from "../../images/icons/pinterest_result.webp"

const ClickHandler = () => {
  window.scrollTo(10, 0)
}

const SubmitHandler = (e) => {
  e.preventDefault()
}

const Footer = (props) => {
  return (
    <footer className="site_footer footer_layout_1">
      <div className="content_box" style={{ backgroundImage: `url(${Bg})` }}>
        <div className="container">
          <div className="diract_contact_links text-white">
            <div className="iconbox_block layout_icon_left">
              <div className="iconbox_icon">
                <img src={icon1} alt="Mail SVG Icon" />
              </div>
              <div className="iconbox_content">
                <h3 className="iconbox_title">Write to us</h3>
                <p className="mb-0">info@rashtechinfo.com</p>
              </div>
            </div>
            <div className="iconbox_block layout_icon_left">
              <div className="iconbox_icon">
                <img src={icon2} alt="Calling Check SVG Icon" />
              </div>
              <div className="iconbox_content">
                <h3 className="iconbox_title"> Call Us (IND)</h3>
                <p className="mb-0">+91 80940 94653</p>
              </div>
            </div>
            <div className="iconbox_block layout_icon_left">
              <div className="iconbox_icon">
                <img src={icon3} alt="Map Mark Check SVG Icon" />
              </div>
              <div className="iconbox_content">
                <h3 className="iconbox_title">Our Office</h3>
                <p className="mb-0">
                  Shiv Complex, Near Dussehra <br /> Maidan, Alwar (Rajasthan)
                </p>
              </div>
            </div>
          </div>
          <div className="footer_main_content">
            <div className="row justify-content-lg-between">
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="footer_widget pe-md-3">
                  <img
                    src={logo}
                    alt="RashTech-logo"
                    style={{ marginBottom: "20px" }}
                  />
                  <p style={{ marginLeft: "20px" }}>
                    RashTech Info is a 2018-founded Alwar-based agency
                    delivering web, app, UI/UX, and digital marketing solutions
                    for growing businesses.
                  </p>
                  <ul className="social_links_block unordered_list">
                    <li>
                      <a
                        href="https://www.facebook.com/rashtechinfo"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={facebook}
                          alt="Facebook Icon"
                          style={{ width: "18px" }}
                        />
                      </a>
                    </li>
                    <li>
                      <a href="https://x.com/rashtechinfo" target="_blank" rel="noreferrer">
                        <img src={x} alt="X Icon" style={{ width: "18px" }} />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/rashtechinfo"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={instagram}
                          alt="Instagram Icon"
                          style={{ width: "18px" }}
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/company/officialrashtechinfo"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={linkedin}
                          alt="LinkedIn Icon"
                          style={{ width: "18px" }}
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://in.pinterest.com/rashtech_info"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={pinterest}
                          alt="Pinterest Icon"
                          style={{ width: "18px" }}
                        />
                      </a>
                    </li>
                    
                    <li>
                      <a href="https://www.youtube.com/@officialrashtechinfo" target="_blank" rel="noreferrer">
                        <img src={youtube} alt="YouTube Icon" style={{ width: "18px" }} />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              
              {/* First Column - Quick Links */}
              <div className="col-lg-2 col-md-6 col-sm-6">
                <div className="footer_widget">
                  <h3 className="footer_info_title">Quick Links</h3>
                  <ul className="icon_list unordered_list_block" >
                    <li>
                      <Link onClick={ClickHandler} to="/">
                        <span className="icon_list_text">Home</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/about">
                        <span className="icon_list_text">About Us</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/blog">
                        <span className="icon_list_text">Blogs</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/portfolio">
                        <span className="icon_list_text">Portfolio</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/case-study">
                        <span className="icon_list_text">Case Study</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/career">
                        <span className="icon_list_text">Career</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/team">
                        <span className="icon_list_text">Our Team</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/contact">
                        <span className="icon_list_text">Contact Us</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              
              {/* Second Column - Services */}
              <div className="col-lg-2 col-md-6 col-sm-6">
                <div className="footer_widget">
                  <h3 className="footer_info_title">Services</h3>
                  <ul className="icon_list unordered_list_block" >
                    {Services.slice(0).map((service, srv) => (
                      <li key={srv}>
                        {service.footer ? (
                          <Link
                            onClick={ClickHandler}
                            to={`/${service.slug}`}
                          >
                            <span className="icon_list_text">
                              {service.footer}
                            </span>
                          </Link>
                        ) : (
                          ""
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              
              {/* Third Column - Our Industries (Product ki jagah) */}
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="footer_widget">
                  <h3 className="footer_info_title">Our Industries</h3>
                  <ul className="icon_list unordered_list_block">
                    <li>
                      <Link onClick={ClickHandler} to="/industries/healthcare">
                        <span className="icon_list_text">Healthcare</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/education">
                        <span className="icon_list_text">Education & E‑Learning</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/finance">
                        <span className="icon_list_text">Finance</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/legal-consultancy">
                        <span className="icon_list_text">Legal & Consultancy</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/logistics">
                        <span className="icon_list_text">Logistics</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/insurance">
                        <span className="icon_list_text">Insurance</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/manufacturing">
                        <span className="icon_list_text">Manufacturing</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/travel">
                        <span className="icon_list_text">Travel</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/retail">
                        <span className="icon_list_text">Retail</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/construction">
                        <span className="icon_list_text">Construction</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/sports">
                        <span className="icon_list_text">Sports</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/marketplace">
                        <span className="icon_list_text">Marketplace</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/beauty-lifestyle">
                        <span className="icon_list_text">Beauty & Lifestyle</span>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/industries/on-demand">
                        <span className="icon_list_text">On Demand</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer_bottom">
        <div className="container d-md-flex align-items-md-center justify-content-md-between">
          <p className="copyright_text m-0">
            Copyright © {new Date().getFullYear()} - RashTech Info. All Rights
            Reserved.
          </p>
          <div className="copyright_text m-0">
            <Link onClick={ClickHandler} to="/privacy-policy" style={{ marginRight: "10px" }}>Privacy Policy</Link>
            <span>|</span>
            <Link onClick={ClickHandler} to="/terms-and-conditions" style={{ marginLeft: "10px" }}>Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
